import {
  collection, getFirestore, or, query, where,
} from 'firebase/firestore';

// https://firebase.google.com/docs/firestore/query-data/queries#in_not-in_and_array-contains-any
const MAX_DOMAIN_DISJUNCTIONS = 29;

/**
 * @param {string} domainsStr - comma separated domains string, e.g. "domain1.com, domain2.com"
 * Because Array will trigger React re-render more easily than string,
 * we use comma separated domains string as the parameter for easier usage in React components.
 * The function will split the string into array, trim spaces, remove empty
 * values, de-duplicate, and cap domain filters to stay within Firestore's
 * OR query disjunction limit.
 */
export default function getSearchOrgUsersQuery({ orgId, domainsStr = '' }) {
  if (!orgId) return null;

  const domains = [...new Set(
    domainsStr
      .split(',')
      .map((domain) => domain.trim())
      .filter(Boolean),
  )].slice(0, MAX_DOMAIN_DISJUNCTIONS);

  if (domains.length > 0) {
    return query(
      collection(getFirestore(), 'users'),
      or(
        where('organization', '==', orgId),
        where('domain', 'in', domains),
      ),
    );
  }

  return query(
    collection(getFirestore(), 'users'),
    where('organization', '==', orgId),
  );
}
